const reasons = [
  {
    icon: 'ri-map-2-line',
    title: 'Multi-State Coverage',
    desc: 'Operational presence across Texas, Louisiana, North Carolina, and Georgia with dedicated regional teams.',
  },
  {
    icon: 'ri-thunderstorms-line',
    title: 'Storm Restoration Expertise',
    desc: 'Deep experience handling hurricane and storm-related damage — from hail to wind to flooding aftermath.',
  },
  {
    icon: 'ri-history-line',
    title: 'Proven Track Record',
    desc: 'Over two decades serving thousands of satisfied customers with a reputation built on quality and reliability.',
  },
  {
    icon: 'ri-medal-2-line',
    title: 'Premium Certifications',
    desc: 'Recognized as an Owens Corning Platinum Preferred Contractor — the highest level of certification available.',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: 'Insurance Claim Support',
    desc: 'Expert guidance through complex insurance processes for faster approvals and maximum claim coverage.',
  },
  {
    icon: 'ri-team-line',
    title: 'Experienced Crews',
    desc: '100+ years of combined experience across our teams, ensuring every project is handled by true professionals.',
  },
];

const galleryImages = [
  {
    src: 'https://public.readdy.ai/ai/img_res/8f2353697efb2830c26f6f49739fd08e.jpg',
    alt: 'Completed luxury roof replacement',
    span: 'row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=professional%20roofing%20crew%20team%20photo%20in%20uniform%20standing%20proudly%20in%20front%20of%20completed%20residential%20project%2C%20sunny%20day%2C%20confident%20team%2C%20Southeast%20USA%20neighborhood%2C%20high%20quality%20photography&width=600&height=400&seq=why_gal_02&orientation=landscape',
    alt: 'PRA Roof Contractors team',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Owens%20Corning%20premium%20roofing%20shingles%20close-up%20detail%2C%20high%20quality%20architectural%20shingles%20texture%2C%20rich%20dark%20charcoal%20color%2C%20premium%20materials%2C%20sharp%20macro%20photography&width=600&height=400&seq=why_gal_03&orientation=landscape',
    alt: 'Premium Owens Corning materials',
    span: '',
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-28 bg-[#f7f6f4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-[#c0392b] text-xs font-bold tracking-widest uppercase mb-3 block">Why PRA</span>
          <h2 className="text-4xl md:text-5xl font-black text-[#1a1a1a] leading-tight">
            The Southeast's Most Trusted<br />Roofing Team
          </h2>
        </div>

        {/* Main layout */}
        <div className="flex flex-col lg:flex-row gap-10 items-start">
          {/* Left — image gallery */}
          <div className="lg:w-5/12">
            <div className="grid grid-cols-2 gap-3 h-[520px]">
              {/* Tall left image */}
              <div className="row-span-2 rounded-2xl overflow-hidden h-full">
                <img
                  src={galleryImages[0].src}
                  alt={galleryImages[0].alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Two stacked right images */}
              <div className="rounded-2xl overflow-hidden">
                <img
                  src={galleryImages[1].src}
                  alt={galleryImages[1].alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img
                  src={galleryImages[2].src}
                  alt={galleryImages[2].alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Stats strip */}
            <div className="grid grid-cols-3 gap-3 mt-3">
              {[
                { val: '1998', label: 'Est.' },
                { val: '20K+', label: 'Customers' },
                { val: '100+', label: 'Yrs Experience' },
              ].map((stat, i) => (
                <div key={i} className="bg-[#1a1a1a] rounded-xl p-4 text-center">
                  <p className="text-white font-black text-xl">{stat.val}</p>
                  <p className="text-white/40 text-xs mt-0.5">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — reasons grid */}
          <div className="lg:w-7/12">
            <p className="text-[#555] text-sm leading-relaxed mb-10 max-w-lg">
              Since 1998, PRA Roof Contractors has built a reputation as the region's premier roofing and storm restoration authority — combining premium certifications, multi-state reach, and unmatched customer service.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {reasons.map((r, i) => (
                <div
                  key={i}
                  className="group bg-white rounded-xl p-6 border border-transparent hover:border-[#c0392b]/30 transition-all duration-300 cursor-default"
                >
                  <div className="w-11 h-11 flex items-center justify-center bg-[#c0392b]/10 rounded-xl mb-4 group-hover:bg-[#c0392b] transition-colors duration-300">
                    <i className={`${r.icon} text-[#c0392b] text-lg group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <h3 className="text-[#1a1a1a] font-bold text-base mb-2">{r.title}</h3>
                  <p className="text-[#777] text-sm leading-relaxed">{r.desc}</p>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 mt-8 bg-[#1a1a1a] hover:bg-[#c0392b] text-white font-bold px-8 py-4 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line"></i>
              Get a Free Inspection
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
